import { render, staticRenderFns } from "./withdrawalStatusListPage.vue?vue&type=template&id=48ba2946&scoped=true"
import script from "./withdrawalStatusListPage.vue?vue&type=script&lang=js"
export * from "./withdrawalStatusListPage.vue?vue&type=script&lang=js"
import style0 from "./withdrawalStatusListPage.vue?vue&type=style&index=0&id=48ba2946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba2946",
  null
  
)

export default component.exports